module.exports = __webpack_public_path__ + "assets/clock.194bf583.svg";